/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        
        $('ul.nav li.dropdown').hover(function() {
          $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeIn(300);
        }, function() {
          $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeOut(300);
        });        
        
        // LINKS
  
        $(document).ready(function(){
            $("li.menu-item a").removeAttr("title");
        }); 
        
//        // SIDEBAR HEIGHT
//        $(function() {
//          $('.height-col').matchHeight();
//        });  
        
        // EXCERPT HEIGHT
        $(function() {
          $('.excerpt-container').matchHeight();
        });
        
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        
        var wallopEl = document.querySelector('.Wallop');
        var wallop = new Wallop(wallopEl);

        // To start Autoplay, just call the function below
        // and pass in the number of seconds as interval
        // if you want to start autoplay after a while
        // you can wrap this in a setTimeout(); function
        autoplay(4000);

        // This a a helper function to build a simple
        // auto-play functionality. 
        function autoplay(interval) {
          var lastTime = 0;  

          function frame(timestamp) {
            var update = timestamp - lastTime >= interval;

            if (update) {
              wallop.next();
              lastTime = timestamp;
            }

            requestAnimationFrame(frame);
          }

          requestAnimationFrame(frame);
        }; 

          $('.kadra_slider').slick({
            
//            dots: true,
            arrows: true,
            nextArrow: '<button type="button" class="slick-2-next"></button>',
            prevArrow: '<button type="button" class="slick-2-prev"></button>',            
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            speed: 300,
//            centerMode: true,
//            variableWidth: true,
            autoplay: true,
            autoplaySpeed: 2500,  
            pauseOnFocus: false,
            pauseOnHover: true,
            responsive: [
                {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,                    
                  }
                },
                {
                  breakpoint: 800,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,                                        
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1, 
                  }
                }            
            ]            

          });          
        
          $('.partnerzy_slider').slick({
            
//            dots: true,
            arrows: true,
            nextArrow: '<button type="button" class="slick-2-next"></button>',
            prevArrow: '<button type="button" class="slick-2-prev"></button>',            
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            speed: 300,
//            centerMode: true,
//            variableWidth: true,
            autoplay: true,
            autoplaySpeed: 2500,  
            pauseOnFocus: false,
            pauseOnHover: true,
            responsive: [
                {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,                    
                  }
                },
                {
                  breakpoint: 800,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,                                        
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1, 
                  }
                }            
            ]            

          });         
        
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // Partnerzy page, note the change from about-us to about_us.
    'nasi_partnerzy': {
      init: function() {
        // JavaScript to be fired on the about us page
        $(function() {
          $('.partnerzy-box').matchHeight();
        });
        
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
